import React, { useState } from 'react';
import '../styles/Chatbot.css';

const Chatbot = () => {
  const [isOpen, setIsOpen] = useState(false);
  const [messages, setMessages] = useState([
    { from: 'bot', text: 'Hello! Welcome to Dani Import & Export. How can I help you today?' },
  ]);
  const [input, setInput] = useState('');

  const getBotResponse = (userMessage) => {
    const message = userMessage.toLowerCase().trim();
    
    // Greetings
    if (message.includes('hi') || message.includes('hello') || message.includes('hey') || message.includes('good morning') || message.includes('good afternoon')) {
      return "Hello! Welcome to Dani Import & Export. How can I assist you with international trade today?";
    }
    
    // About company
    if (message.includes('about') || message.includes('who are you') || message.includes('company') || message.includes('what is dani')) {
      return "Dani Import & Export is a professional trading company based in Shanghai, China. We provide seamless import/export solutions for businesses worldwide.";
    }
    
    // Services
    if (message.includes('service') || message.includes('what do you do') || message.includes('offer') || message.includes('help') || message.includes('assist')) {
      return "We offer: Import/Export solutions, Freight Forwarding, Canton Fair Packages, Visa Assistance, Translation, Discount Shipping, and Market Research.";
    }
    
    // Shipping/Import/Export specific queries
    if (message.includes('shipping') || message.includes('delivery') || message.includes('freight') || 
        message.includes('import') || message.includes('export') || 
        message.includes('product from china') || message.includes('buy from china') ||
        message.includes('ship from china') || message.includes('import from china') ||
        message.includes('sourcing') || message.includes('procurement')) {
      return "We provide comprehensive import/export services from China including sourcing, freight forwarding, customs clearance, and delivery to your destination country. Would you like to know more about our specific import/export solutions?";
    }
    
    // Canton Fair
    if (message.includes('canton fair') || message.includes('fair') || message.includes('guangzhou') || message.includes('trade show') || message.includes('exhibition')) {
      return "We offer complete Canton Fair packages including business tours, accommodation, visa assistance, translation services, and local support.";
    }
    
    // China support
    if (message.includes('china') || message.includes('local') || message.includes('support') || 
        message.includes('chinese') || message.includes('in china') || 
        message.includes('china support') || message.includes('local support')) {
      return "We provide direct local support in China including translation, sourcing, factory visits, quality control, and business assistance.";
    }
    
    // Contact
    if (message.includes('contact') || message.includes('whatsapp') || message.includes('email') || 
        message.includes('wechat') || message.includes('phone') || message.includes('number') ||
        message.includes('reach') || message.includes('get in touch')) {
      return "Contact us: WhatsApp/WeChat: +17772063984 or +251989351570, Email: daniimportandexport0@gmail.com";
    }
    
    // Pricing
    if (message.includes('price') || message.includes('cost') || message.includes('how much') || 
        message.includes('quote') || message.includes('pricing') || message.includes('rate')) {
      return "Our services are customized for each client. Please contact us for a personalized quote based on your specific needs.";
    }
    
    // Location
    if (message.includes('where') || message.includes('location') || message.includes('based') || 
        message.includes('address') || message.includes('headquarter')) {
      return "We are based in Shanghai, China, serving clients worldwide with professional import/export solutions.";
    }
    
    // Questions about process
    if (message.includes('how') || message.includes('process') || message.includes('work') || 
        message.includes('procedure') || message.includes('step') || message.includes('way')) {
      return "Our process involves: 1) Understanding your requirements, 2) Sourcing products, 3) Quality checks, 4) Shipping arrangements, 5) Customs clearance, and 6) Delivery. Contact us for more details!";
    }
    
    // Default response for other queries
    return "Thank you for your message! For detailed information about our import/export services, please contact us directly at +17772063984 or daniimportandexport0@gmail.com";
  };

  const sendMessage = () => {
    if (!input.trim()) return;
    
    // Add user message
    const userMessage = input;
    setMessages([...messages, { from: 'user', text: userMessage }]);
    setInput('');
    
    // Get and add bot response
    setTimeout(() => {
      const botResponse = getBotResponse(userMessage);
      setMessages((msgs) => [...msgs, { from: 'bot', text: botResponse }]);
    }, 1000);
  };

  return (
    <div className={`chatbot ${isOpen ? 'open' : ''}`}>
      {/* Chat icon when closed */}
      {!isOpen && (
        <button
          className="chatbot-icon"
          onClick={() => setIsOpen(true)}
          aria-label="Open chatbot"
        >
          💬
        </button>
      )}
      
      {/* Chat window when open */}
      {isOpen && (
        <div className="chat-window">
          <div className="chat-header">
            <span>Dani Import & Export Trading</span>
            <button 
              className="close-button"
              onClick={() => setIsOpen(false)}
              aria-label="Close chatbot"
            >
              ✕
            </button>
          </div>
          <div className="messages">
            {messages.map((msg, i) => (
              <div key={i} className={`message ${msg.from}`}>
                {msg.text}
              </div>
            ))}
          </div>
          <div className="input-container">
            <input
              type="text"
              value={input}
              onChange={(e) => setInput(e.target.value)}
              onKeyDown={(e) => e.key === 'Enter' && sendMessage()}
              placeholder="Type your message..."
            />
            <button onClick={sendMessage}>Send</button>
          </div>
        </div>
      )}
    </div>
  );
};

export default Chatbot;


